export function getBase64(file) {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function() {
    console.log(reader.result);
  };
  reader.onerror = function(error) {
    console.log("Error: ", error);
  };
}
export default function getPhoneFormat(value) {
  return value.replace(/\D+/g, "").replace(/(\d{3})(\d{3})/, "$1 $2 ");
}



// WEBPACK FOOTER //
// ./src/Helpers/Util.ts